module.exports = __webpack_public_path__ + "static/media/LemonIsotipo.42a04f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LemonIsotipo.png
// module id = 370
// module chunks = 0